import { render, staticRenderFns } from "./SurfLogo.vue?vue&type=template&id=675ab9c4&lang=pug&"
import script from "./SurfLogo.vue?vue&type=script&lang=js&"
export * from "./SurfLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports